<template>
      <div class="index container">

        <transition name="fade">
          <router-view @showParent="showParent">
          </router-view>
        </transition>
        
        <div v-if="showParentPage">
          <v-breadcrumbs>
            <v-breadcrumbs-item :exact="true" :to="{ name: 'home', params: {} }"
              >Home</v-breadcrumbs-item
            >
            <v-breadcrumbs-divider>/</v-breadcrumbs-divider>
            <v-breadcrumbs-item
              :exact="true"
              :to="{ name: 'page', params: {} }"
              active
            >
              Page
            </v-breadcrumbs-item>
          </v-breadcrumbs>

        <div class="d-flex flex-column flex-lg-row">
          <v-text-field
            dense
            v-model="searchTerms"
            @keyup.enter="search"
            @click:clear="clearSearch"
            @click:append="search"
            placeholder="Press enter to begin search"
            append-icon="mdi-magnify"
            outlined
            clearable
            label="Search"
          />
          <v-btn
            class="ml-0 ml-lg-4 mb-2 mb-lg-0 align-self-end align-self-lg-start"
            color="primary"
            :to="{ name: 'pageCreate', params: {} }"
          >
            Create Page
          </v-btn>
        </div>

        <div class="table-container">
          <v-data-table
            :headers="headers"
            :items="pageList"
            :items-per-page="pagination.pageSize"
            :loading="!pageProcessed"
            :server-items-length="pagination.totalSize"
            :page="pagination.current"
            :disable-sort="true"
            item-key="id"
            class="elevation-1"
            @update:options="pageChanged"
          >
            
            <template v-slot:item.endpoint="{ item }">
              <a @click="view(item)">{{ item.endpoint }}</a>
            </template>
            
            <template v-slot:item.endpoint_module="{ item }">
              <a @click="view(item)">{{ item.endpoint_module }}</a>
            </template>
            
            <template v-slot:item.icon="{ item }">
              <a @click="view(item)">{{ item.icon }}</a>
            </template>
            
            <template v-slot:item.default_param="{ item }">
              <a @click="view(item)">{{ item.default_param }}</a>
            </template>
            
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="edit(item)">
                mdi-pencil
              </v-icon>
              <v-icon small class="mr-2" @click="remove(item)">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </div>
      </div>
      <confirmation-dialog ref="confirm" />
    </div>
  </template>

    <script>
    import { mapActions, mapGetters } from "vuex";
    const ConfirmationDialog = () =>
    import("@/components/common/ConfirmationDialog.vue");
  
    export default {
      data(){
        return {
          pagination: {
            current: 1,
            pageSize: 10,
            totalSize: 100
          },
          pageList: [],
          showParentPage: true,
          
      headers: [
        {
          text: "Label",
          value: "label",
          align: "start",
          sortable: true
        },
        {
          text: "Endpoint",
          value: "endpoint",
          align: "start",
          sortable: false
        },
        {
          text: "Endpoint Module",
          value: "endpoint_module",
          align: "start",
          sortable: false
        },
        {
          text: "Icon",
          value: "icon",
          align: "start",
          sortable: false
        },
        {
          text: "Default Params",
          value: "default_param",
          align: "start",
          sortable: false
        },
        
        { text: "Actions", value: "actions", align: "end", sortable: false }
      ],
          sort: {
            key: null
          },
          searchTerms : ''
        }
      },
      components: {
        ConfirmationDialog
      },
      computed: {
        ...mapGetters("page", ["pageProcessed", "getPages"]),
      },
      methods: {
        ...mapActions("messages", [
          "addErrorMessage",
          "addMessage",
          "addSuccessMessage"
        ]),
        ...mapActions("page", ["deletePage", "fetchPages"]),
        view(item){
          this.$router.push({ name: 'pageView', params: { id: item.id }})
        },
        edit(item){
          this.$router.push({ name: "pageEdit", params: { id: item.id }})
        },
        async remove(item){
          let confirm = await this.$refs.confirm.open(
            "Confirm Delete",
            "Do you want to delete this page?"
          );
          if(confirm){
            this.deletePage(item.id)
              .then( () => {
                this.addSuccessMessage("page was deleted with successfull!");
                this.getResources();
              }).catch( () => {
                this.addErrorMessage("Server response with error ");
              });
          }
        },
        getResources() {
          const params = {
            page: this.pagination.pageIndex && this.pagination.pageIndex > 0 ? this.pagination.pageIndex-1:0,
            size: this.pagination.pageSize,
          };
          this.fetchPages(params)
            .then(response => {
              if(response){
                this.pagination.totalSize = response.totalElements;
                this.pageList = response.content;
              }
            })
            .catch(error => {
              this.addErrorMessage("Server response with error " + error);
            });
        },
        showParent(show) {
          this.showParentPage = show;
        },
        pageChanged(pagination) {
          this.pagination.pageIndex = pagination.page;
          this.pagination.pageSize = pagination.itemsPerPage;

          this.getResources()
        },
        search(){
          this.getResources();
        },
        clearSearch(){
          this.searchTerms = null;
          this.getResources();
        }
      },
      watch: {
        'pagination.numberRegisterForPage': function(){
            this.pagination.current = -1;
        },
      },
      beforeRouteUpdate(to, from, next) {
        const toDepth = to.path.split("/").length;
        const fromDepth = from.path.split("/").length;
        this.showParentPage = toDepth < fromDepth;
        if (this.showParentPage) {
          this.getResources();
        }
        next();
      }
    }
    </script>

    